import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { scrollTo } from "@/lib/lenis";

const PATHS = [
  {
    n: "01",
    title: "Jestem nauczycielką / lektorką",
    desc: "Chcę lepiej uczyć, rozwijać warsztat metodyczny i mieć pod ręką praktyczne narzędzia.",
    cta: "Abonament nauczycielski",
    to: "#nauczycielki",
    id: "teacher",
    theme: {
      card: "border border-ink/15 bg-white",
      num: "text-red",
      title: "text-ink",
      desc: "text-ink/60",
      cta: "text-ink group-hover:text-red",
    },
  },
  {
    n: "02",
    title: "Jestem właścicielką szkoły językowej",
    desc: "Chcę uporządkować procesy, rozwijać zespół i administrację oraz pracować z firmami.",
    cta: "Abonament właścicielski",
    to: "#wlascicielki",
    id: "owner",
    theme: {
      card: "bg-red",
      num: "text-white/70",
      title: "text-white",
      desc: "text-white/80",
      cta: "text-white group-hover:text-white/80",
    },
  },
  {
    n: "03",
    title: "Jestem właścicielką szkoły i jednocześnie lektorką",
    desc: "Chcę korzystać z materiałów właścicielskich i jednocześnie dać bibliotekę moim nauczycielom.",
    cta: "Abonament „Chcę mieć wszystko”",
    to: "#mam-wszystko",
    id: "all",
    theme: {
      card: "bg-ink",
      num: "text-red",
      title: "text-white",
      desc: "text-white/65",
      cta: "text-white group-hover:text-red",
    },
  },
];

export const PathChooser = () => (
  <section id="abonamenty" data-testid="path-chooser-section" className="bg-alabaster py-20 sm:py-28">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <Reveal className="max-w-[720px]">
        <Eyebrow>Zacznij tutaj</Eyebrow>
        <h2 className="font-display mt-5 text-4xl font-medium leading-[1.02] tracking-[-0.02em] text-ink sm:text-5xl lg:text-6xl">
          Kim jesteś?
        </h2>
        <p className="mt-5 max-w-[56ch] text-base leading-relaxed text-ink/65 sm:text-lg">
          Są trzy ścieżki. Wybierz tę, która opisuje Twoją rolę, a pokażemy Ci tylko to, co jest dla Ciebie.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-4 lg:grid-cols-3 lg:gap-0">
        {PATHS.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.1} className="flex">
            <a
              href={p.to}
              data-testid={`path-chooser-${p.id}-card`}
              onClick={(e) => {
                e.preventDefault();
                scrollTo(p.to);
              }}
              className={`path-card group flex h-full w-full flex-col justify-between px-7 py-10 transition-transform duration-500 hover:-translate-y-1 sm:px-9 lg:py-12 ${p.theme.card}`}
            >
              <div>
                <span className={`font-display text-sm ${p.theme.num}`}>{p.n}</span>
                <h3 className={`font-display mt-4 text-2xl font-medium leading-tight sm:text-3xl ${p.theme.title}`}>{p.title}</h3>
                <p className={`mt-4 text-[15px] leading-relaxed ${p.theme.desc}`}>{p.desc}</p>
              </div>
              <span className={`mt-10 inline-flex items-center gap-2 text-[13px] font-semibold uppercase tracking-[0.14em] transition-colors ${p.theme.cta}`}>
                {p.cta}
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
              </span>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
